// Hands the /try visitor's email and first name to /auth without putting personal data in
// URLs (which end up in GA, logs and browser history). sessionStorage only, cleared once used.

const KEY = 'wa_signup_prefill';

export interface SignupPrefill {
  email: string;
  firstName?: string;
}

export function setSignupPrefill(prefill: SignupPrefill): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(prefill));
  } catch {
    // Storage unavailable (private mode): the form just starts empty.
  }
}

// Read without removing (React may call state initialisers twice in development);
// call clearSignupPrefill() once the values are in the form.
export function readSignupPrefill(): SignupPrefill | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return typeof parsed?.email === 'string' ? parsed : null;
  } catch {
    return null;
  }
}

export function clearSignupPrefill(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
